import { Outlet, Link } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className='min-h-screen bg-apple-light-gray'>
      <nav
        className='h-12 flex items-center border-b border-apple-border'
        style={{
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'saturate(180%) blur(20px)',
          WebkitBackdropFilter: 'saturate(180%) blur(20px)',
        }}
      >
        <div className='max-w-[980px] mx-auto w-full px-6'>
          <Link to='/' className='text-apple-near-black font-semibold text-[17px] tracking-tight'>
            CodePilot
          </Link>
        </div>
      </nav>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
